import PartPurchaseQualityControl from '@/models/PartPurchaseQualityControl/PartPurchaseQualityControl';

export default class PartPurchaseQualityControlFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.partPurchaseQualityControlDateFrom = '';
		this.partPurchaseQualityControlDateTo = '';
		this.descriptionMultiple = '';
		this.qcQty = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			partPurchaseQualityControlDateFrom : '0',
			partPurchaseQualityControlDateTo : '0',
			descriptionMultiple : '0',
			qcQty : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}